/* PlyPro B2B — interacción de la página (layout "plypro" de Shopify) */
(function () {
  "use strict";
  var root = document.documentElement;
  var scroller = document.getElementById("scroller");
  var HH = 64;
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var design = !!(window.Shopify && window.Shopify.designMode);
  root.classList.add("js");
  if (design) root.classList.add("pp-design");

  /* ¿El scroll lo lleva .scroller (escritorio) o la ventana (móvil/editor)? */
  function snapMode() {
    return getComputedStyle(scroller).overflowY !== "visible" &&
           scroller.scrollHeight > scroller.clientHeight + 4;
  }

  function goTo(id) {
    var target = document.getElementById(id);
    if (!target) return;
    var offset = target.classList.contains("panel") ? 0 : HH;
    var behavior = reduce ? "auto" : "smooth";
    if (snapMode()) {
      var top = target.getBoundingClientRect().top - scroller.getBoundingClientRect().top + scroller.scrollTop;
      scroller.scrollTo({ top: top - offset, behavior: behavior });
    } else {
      window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - offset, behavior: behavior });
    }
  }

  /* ------------------------ Animaciones de entrada ---------------------- */
  var io = ("IntersectionObserver" in window && !reduce && !design) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add("in"); io.unobserve(en.target); } });
  }, { threshold: 0.16, rootMargin: "0px 0px -8% 0px" }) : null;
  function initReveals(scope) {
    var els = (scope || document).querySelectorAll(".reveal:not(.in)");
    els.forEach(function (el) { if (io) io.observe(el); else el.classList.add("in"); });
    setTimeout(function () { els.forEach(function (el) { el.classList.add("in"); }); }, 2600); // seguro
  }

  /* --------------- Puntos de sección (se generan solos) ----------------- */
  var dotsBox = document.getElementById("dots");
  var panels = [];
  function buildDots() {
    panels = Array.prototype.slice.call(document.querySelectorAll(".panel[data-dot]"));
    if (!dotsBox) return;
    dotsBox.innerHTML = "";
    panels.forEach(function (p) {
      var b = document.createElement("button");
      b.type = "button"; b.dataset.target = p.id; b.setAttribute("aria-label", p.dataset.dot);
      b.addEventListener("click", function () { goTo(p.id); });
      dotsBox.appendChild(b);
    });
    syncActive();
  }
  function syncActive() {
    if (!panels.length) return;
    var line = (snapMode() ? scroller.clientHeight : window.innerHeight) * 0.42;
    var top = snapMode() ? scroller.getBoundingClientRect().top : 0;
    var id = panels[0].id;
    panels.forEach(function (p) {
      var r = p.getBoundingClientRect();
      if (r.top - top <= line) id = p.id;
    });
    if (dotsBox) Array.prototype.forEach.call(dotsBox.children, function (b) {
      b.setAttribute("aria-current", b.dataset.target === id ? "true" : "false");
    });
    document.querySelectorAll(".site-nav a").forEach(function (a) {
      a.classList.toggle("is-active", a.getAttribute("href") === "#" + id);
    });
  }
  var ticking = false;
  function onScroll() {
    if (!ticking) { ticking = true; requestAnimationFrame(function () { syncActive(); ticking = false; }); }
  }
  scroller.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", syncActive);

  /* --------------- Clics (delegados: sobreviven al editor) -------------- */
  document.addEventListener("click", function (e) {
    var a = e.target.closest('a[href^="#"]');
    if (a) {
      var id = a.getAttribute("href").slice(1);
      if (id && document.getElementById(id)) { e.preventDefault(); closeMenu(); goTo(id); }
      return;
    }
    if (e.target.closest(".nav-toggle")) {
      var menu = document.getElementById("mobileMenu");
      if (menu) menu.classList.toggle("open");
      return;
    }
    var q = e.target.closest(".faq__q");
    if (q) {
      var item = q.closest(".faq__item"), ans = item.querySelector(".faq__a"), icon = item.querySelector(".faq__icon");
      var open = item.classList.toggle("open");
      if (icon) icon.textContent = open ? "–" : "+";
      ans.style.maxHeight = open ? ans.scrollHeight + "px" : "";
      return;
    }
    var nav = e.target.closest("[data-pf-go]");
    if (nav) { pfStep(nav.closest("[data-pf]"), nav.dataset.pfGo); }
  });
  function closeMenu() { var m = document.getElementById("mobileMenu"); if (m) m.classList.remove("open"); }

  /* ------------------------------ Portfolio ----------------------------- */
  function pad(n) { return n < 10 ? "0" + n : "" + n; }
  function pfShow(box, i) {
    var slides = box.querySelectorAll(".pf-slide");
    if (!slides.length) return;
    i = (i + slides.length) % slides.length;
    box.dataset.i = i;
    slides.forEach(function (s, k) { s.classList.toggle("is-active", k === i); });
    box.querySelectorAll(".pf-dots button").forEach(function (b, k) { b.setAttribute("aria-current", k === i ? "true" : "false"); });
    var c = box.querySelector(".pf-counter");
    if (c) c.textContent = pad(i + 1) + " / " + pad(slides.length) + " · " + (c.dataset.hint || "");
  }
  function pfStep(box, dir) {
    var i = parseInt(box.dataset.i || "0", 10);
    pfShow(box, dir === "prev" ? i - 1 : dir === "next" ? i + 1 : parseInt(dir, 10));
  }
  function initPortfolio(scope) {
    (scope || document).querySelectorAll("[data-pf]").forEach(function (box) {
      var dots = box.querySelector(".pf-dots");
      if (dots) {
        dots.innerHTML = "";
        box.querySelectorAll(".pf-slide").forEach(function (s, k) {
          var b = document.createElement("button");
          b.type = "button"; b.dataset.pfGo = String(k);
          var n = document.createElement("span"); n.className = "pf-dot-n"; n.textContent = s.dataset.num || pad(k + 1);
          b.appendChild(n);
          if (s.dataset.name) { var t = document.createElement("span"); t.className = "pf-dot-t"; t.textContent = s.dataset.name; b.appendChild(t); }
          dots.appendChild(b);
        });
      }
      pfShow(box, 0);
    });
  }

  /* -------------------- Configurador 3D (carga diferida) ---------------- */
  var frames = [];
  function initConfig(scope) {
    (scope || document).querySelectorAll("[data-config-frame]").forEach(function (f) {
      frames.push(f);
      var loading = f.parentNode.querySelector(".config-loading");
      f.addEventListener("load", function () { if (f.getAttribute("src") && loading) loading.style.display = "none"; });
      var load = function () { if (!f.getAttribute("src")) f.setAttribute("src", f.dataset.src); };
      if ("IntersectionObserver" in window && !design) {
        var o = new IntersectionObserver(function (es) {
          es.forEach(function (en) { if (en.isIntersecting) { load(); o.disconnect(); } });
        }, { rootMargin: "300px 0px" });
        o.observe(f);
      } else { load(); }
    });
  }
  // El configurador avisa (postMessage) para bajar al contacto. Solo se acepta de nuestro iframe.
  window.addEventListener("message", function (e) {
    var ok = frames.some(function (f) { return f.contentWindow === e.source; });
    if (!ok || !e.data || e.data.plypro !== "goto" || !e.data.id) return;
    goTo(String(e.data.id).replace(/[^a-z0-9_-]/gi, ""));
  });

  /* ----------------------------- Arranque -------------------------------- */
  initReveals();
  initPortfolio();
  initConfig();
  buildDots();
  // Tras enviar el formulario, Shopify recarga la página: bajar al contacto
  if (/[?&]contact_posted=true/.test(location.search) || document.querySelector(".form-success, .form__errors")) {
    setTimeout(function () { goTo("contacto"); }, 300);
  }

  // Editor de temas: re-iniciar la sección que se recarga
  document.addEventListener("shopify:section:load", function (e) {
    initReveals(e.target); initPortfolio(e.target); initConfig(e.target); buildDots();
  });
  document.addEventListener("shopify:section:unload", function () { setTimeout(buildDots, 0); });
  document.addEventListener("shopify:block:select", function (e) {
    var slide = e.target.closest(".pf-slide");
    if (slide) {
      var box = slide.closest("[data-pf]");
      pfShow(box, Array.prototype.indexOf.call(box.querySelectorAll(".pf-slide"), slide));
    }
  });
})();
